// ─────────────────────────────────────────────
//  App.js — StockIQ Portal Root
//  Sets up React Router v6 with:
//    - Public route:    /login
//    - Protected routes for all other pages
//    - Navbar shown on all authenticated pages
// ─────────────────────────────────────────────
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navbar from "./components/Navbar";
import IntelligenceBoard from "./pages/IntelligenceBoard";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import StockAnalysis from "./pages/StockAnalysis";
import Portfolio from "./pages/Portfolio";
import Watchlist from "./pages/Watchlist";
import Alerts from "./pages/Alerts";
import LearnPage from './pages/Learnpage'
import SimulationEngine from "./pages/SimulationEngine";

import "./App.css";

// Layout wrapper: Navbar + page content
// Only rendered for authenticated routes
function AppLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* ── Public ── */}
          <Route path="/login" element={<Login />} />

          {/* ── Protected ── */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Dashboard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/stock/:symbol"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <StockAnalysis />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/portfolio"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Portfolio />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/simulationengine"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <SimulationEngine />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/watchlist"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Watchlist />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/learning"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <LearnPage />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/alerts"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <Alerts />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/board"
            element={
              <ProtectedRoute>
                <AppLayout>
                  <IntelligenceBoard />
                </AppLayout>
              </ProtectedRoute>
            }
          />
          {/* ── Catch-all → Dashboard ── */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
